//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { RoomAlreadyExistsMessage } from './room-already-exists.message';

@PresenterType(
{
    model: RoomAlreadyExistsMessage
})
@Component({
    selector: 'room-already-exists-message-template',
    templateUrl: './room-already-exists-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoomAlreadyExistsMessageTemplateComponent
{
    public data: WritableSignal<RoomAlreadyExistsMessage>;
    
    constructor() {
        this.data = signal<RoomAlreadyExistsMessage>(null);
    }
}